import { cn } from "@/utils/css";

export const Hr = ({ className }) => {
    return <div className={cn("w-full h-[1px] bg-cm-p-outline my-5", className)} />;
};
